import styled from "styled-components";

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: ${(props) => (props.isStacked ? "column" : "row")};
    align-items: center;
    background-color: white;
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    width: 100%;
    height: fit-content;

    background-color: ${(props) => (props.bgColor ? props.bgColor : "white")};
    overflow: hidden;
    cursor: pointer;
    scroll-behavior: smooth;
    touch-action: none;
`;

export const StyledImageWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    aspect-ratio: 1 / 1;

    overflow: hidden;

    ${({ hasLink }) =>
        hasLink &&
        `
        &:hover img,
        &:active img {
            transform: scale(1.1);
            transition: all ease;
            transition-duration: 1s;
        }

        &:hover .ImageOverlay,
        &:active .ImageOverlay {
            opacity: 70%;
        }
    `}
`;

export const StyledOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0%;
    background-color: white;

    transition: opacity ease;
    transition-duration: 1s;
    z-index: 1;
    pointer-events: none;
    ${({ hasLink }) =>
        hasLink &&
        `
    &:hover {
        opacity: 70%;
    }
    `}
`;

export const StyledImage = styled.img`
    &&&&&& {
        width: 100%;
        height: 100%;
        object-fit: cover;
        user-select: none;
        transition: all ease;
        transition-duration: 1s;

        // images have small jump when scaled because scale rounds width/height...
        // need to set scale initially so it's already rounded and doesn't jump
        transform: scale(1.01);
    }
`;
